import React, { FC } from 'react';
import { Button } from 'antd';
import { ReactComponent as OpenIcon } from 'app/assets/images/svg/open-icon.svg';
import { IEventRelatedEvent } from 'entities/Event/Event.models';

interface IComponentProps {
  relatedEvents: IEventRelatedEvent[];
}

export const EventRelatedEvents: FC<IComponentProps> = ({ relatedEvents }) => {
  if (!relatedEvents.length) {
    return null;
  }

  return (
    <div className="event-related-events">
      <div className="subtitle">Other Open Events</div>

      <div className="event-related-events__container">
        {relatedEvents.map((item) => {
          return (
            <Button
              key={item.id}
              className="event-related-events__link"
              type="link"
              onClick={() => window.open(`/event/${item.id}?type=related`, '_blank')}
            >
              <span>{item.type}</span>
              <OpenIcon />
            </Button>
          );
        })}
      </div>
    </div>
  );
};
